export const SectionHeading = ({ overline, title, intro, align = "left", light = false }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {overline && <p className={`overline ${light ? "!text-gold" : ""}`}>{overline}</p>}
    <h2
      className={`font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.08] mt-4 ${
        light ? "text-ivory" : "text-ink"
      }`}
    >
      {title}
    </h2>
    {intro && (
      <p
        className={`text-lg mt-6 font-light leading-relaxed ${
          light ? "text-ivory/70" : "text-ink/80"
        }`}
      >
        {intro}
      </p>
    )}
  </div>
);
